import { render, staticRenderFns } from "./chooseDialog.vue?vue&type=template&id=05c24d1a&scoped=true"
import script from "./chooseDialog.vue?vue&type=script&lang=js"
export * from "./chooseDialog.vue?vue&type=script&lang=js"
import style0 from "./chooseDialog.vue?vue&type=style&index=0&id=05c24d1a&prod&lang=scss"
import style1 from "./chooseDialog.vue?vue&type=style&index=1&id=05c24d1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c24d1a",
  null
  
)

export default component.exports